import React from "react";
import { Card } from "react-bootstrap";
import EventManageNameChange from "./EventManageNameChange";
import EventManageDateChange from "./EventManageDateChange";
import EventManageVenueChange from "./EventManageVenueChange";
import EventManageLayoutsChange from "./EventManageLayoutsChange";
import EventManageGameChange from "./EventManageGameChange";
import EventManageThrowScoringModeChange from "./EventManageThrowScoringModeChange";

function EventManageSettings({ eventId }) {
  return (
    <>
      {/* General Settings Card */}
      <Card
        style={{ borderRadius: "12px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}
        className="mb-4"
      >
        <Card.Header
          style={{
            background: "#2D083F",
            color: "white",
            borderRadius: "12px 12px 0 0",
          }}
        >
          <Card.Title className="mb-0" style={{ color: "white" }}>
            General Settings
          </Card.Title>
        </Card.Header>
        <Card.Body
          style={{
            background: "#FFFFFF",
            borderRadius: "0 0 12px 12px",
            padding: "1.5rem",
          }}
        >
          <EventManageNameChange eventId={eventId} />
          <EventManageDateChange eventId={eventId} />
          <EventManageVenueChange eventId={eventId} />
          <EventManageGameChange eventId={eventId} />
          <EventManageThrowScoringModeChange eventId={eventId} />
          {/* <EventManageScoringChange eventId={eventId} /> */}
        </Card.Body>
      </Card>

      {/* Layout Settings Card */}
      <Card
        style={{ borderRadius: "12px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}
        className="mb-3"
      >
        <Card.Header
          style={{
            background: "#2D083F",
            color: "white",
            borderRadius: "12px 12px 0 0",
          }}
        >
          <Card.Title className="mb-0" style={{ color: "white" }}>
            Layout Settings
          </Card.Title>
        </Card.Header>
        <Card.Body
          style={{
            background: "#FFFFFF",
            borderRadius: "0 0 12px 12px",
            padding: "1.5rem",
          }}
        >
          <EventManageLayoutsChange eventId={eventId} />
          {/* <EventManageGolfScoringChange eventId={eventId} /> */}
        </Card.Body>
      </Card>
    </>
  );
}

export default EventManageSettings;
